<template>
  <div class="priority-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="priorityOptions"
      display-by="label"
      value-by="value"
      :multiple="true"
      v-model="model"
      search-placeholder="Search priority..."
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';

interface PriorityOption {
  label: string;
  value: string;
}

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Priority' 
  }
});

const emit = defineEmits<{
  change: [value: string[]];
}>();

const model = defineModel<string[]>({
  default: () => []
});

const priorityOptions = ref<PriorityOption[]>([
  { label: 'None', value: 'None' },
  { label: 'Low', value: 'Low' },
  { label: 'Medium', value: 'Medium' },
  { label: 'High', value: 'High' },
  { label: 'Critical', value: 'Critical' }
]);

const handleChange = (value: string[]) => {
  emit('change', value);
};
</script>
